import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from '../Page';

function ReportsConversionsGoalManagerPage(): JSX.Element {
  const { t } = useTranslation();

  return <Page title={t('Goal Manager')}>{null}</Page>;
}

export default ReportsConversionsGoalManagerPage;
